import * as React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { Redirect } from '../../utils/redirect'
import { AuthState } from './authState'
import {
  AuthButtonPrimary,
  FormNotification,
  formSkeletonConfig,
  FormSkeletonLayout,
} from '../../utils/forms'
import { getClassName, options } from './utils'
import i18next from 'i18next'

export function signup_logged_in(
  options: options,
  originPath: string,
  type: 'regular' | 'student' | 'promo'
): Widget<Updater<AuthState>> {
  return fromJSX(() =>
    type === 'promo' ? (
      <FormSkeletonLayout
        type="sign-up"
        kind="text-image"
        options={options}
        isClrInverted={true}
        image={formSkeletonConfig.imageDark}
      >
        <header className={getClassName(options, 'headerClassName', 'mb-4')}>
          <h1 className={getClassName(options, 'titleClassName', 'mb-4')}>
            {i18next.t('promoCode:loggedInTitle')}
          </h1>
          <p className={getClassName(options, 'introClassName', 'lead')}>
            {i18next.t('promoCode:loggedInIntro')}
          </p>
        </header>

        <div className={getClassName(options, 'formActionsClassName', '')}>
          <div
            className={getClassName(options, 'clickableWrapperClassName', '')}
          >
            <AuthButtonPrimary
              kind="link"
              to="/"
              label={i18next.t('a11y:navigateHome')}
              disabled={false}
            />
          </div>
        </div>
      </FormSkeletonLayout>
    ) : (
      <Redirect to={originPath} />
    )
  )
}
